module.exports = __webpack_public_path__ + "img/logo-aoqan-text.f94b7af8.svg";